import { PlusOutlined } from "@ant-design/icons"
import { Button, Form, type FormListFieldData, Modal, Select } from "antd"
import { useState } from "react"

import type {
  TemplateDocumentScopeSectionPhase,
  TemplateDocumentScopeSectionProjectTypes
} from "../../../../types/template-document-form-data.tsx"

interface ScopeOfWorkBlockAddMilestoneProps {
  onAddMilestone: (
    defaultValue?: Partial<TemplateDocumentScopeSectionPhase>,
    insertIndex?: number
  ) => void
  fields: FormListFieldData[]
  disabled?: boolean
  projectTypes: TemplateDocumentScopeSectionProjectTypes
}

export function ScopeOfWorkBlockAddMilestone({
  fields,
  disabled,
  projectTypes,
  onAddMilestone
}: ScopeOfWorkBlockAddMilestoneProps) {
  const [open, setOpen] = useState(false)
  const [form] = Form.useForm<{ project_type: string }>()

  const handleOk = () => {
    form.validateFields().then(({ project_type }) => {
      const selected = projectTypes.find((o) => o?.id === project_type)
      onAddMilestone({
        order: fields?.length,
        // Don't ask why it's done this way
        project_type: selected?.id,
        project_type_id: selected?.id,
        project_type_name: selected?.name
      } as Partial<TemplateDocumentScopeSectionPhase>)
      form.resetFields()
      setOpen(false)
    })
  }

  const handleCancel = () => {
    form.resetFields()
    setOpen(false)
  }

  return (
    <>
      <Button
        disabled={disabled}
        type="dashed"
        onClick={() => setOpen(true)}
        block
        icon={<PlusOutlined />}
        className="mt-4"
      >
        Scope of Work
      </Button>

      <Modal
        title="Select Project Type"
        open={open}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Add"
        destroyOnHidden
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="project_type"
            label="Project Type"
            rules={[
              { required: true, message: "Please select a project type" }
            ]}
          >
            <Select
              placeholder="Select project type"
              options={projectTypes.map((o) => ({
                value: o?.id,
                label: o?.name
              }))}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}
